import { useCommand } from '@akin-home/commands-react';
import { useCallback } from 'react';
import { SaveCommand } from '../commands/types';

export const useSaveCommand = (callback: () => void) => {
  useCommand<SaveCommand>(
    'save',
    useCallback(
      (commands) => {
        if (commands.length) {
          callback();
        }
      },
      [callback]
    )
  );

  return callback;
};
